import * as d3 from 'd3-selection'
import wrap from './label-wrap'

export default function (dimensions, fontSize) {

  let draw = function (selection) {
    selection.each(function (data) {
      let label = d3.select(this)
                    .selectAll('g.subtitle')
                    .data(function (d) {
                      let subtitle = d.subtitle
                      if (!subtitle) {
                        return []
                      }
                      return Array.isArray(subtitle) ? subtitle : [subtitle]
                    })

      label.enter()
           .append('g')
             .attr('class', 'subtitle')
             .classed('bottom-label', true)
             .merge(label)
             .each(function () {
               let container = d3.select(this)

               container.attr('transform', `translate(0, ${dimensions.labelHeight})`)
                        .call(wrap, fontSize, dimensions)

               if (container.node()) {
                 dimensions.labelHeight += container.node().getBBox().height
               }
             })

      label.exit().remove()
    })
  }

  return draw
}
